import { Card } from 'antd';
import { OrderDetailGrid } from 'components/ArticleOrder';
import StatusBar from 'components/StatusBar';
import RevertAnswerItem from 'components/RevertAnswerItem';
import ActivityHistory from 'components/ActivityHistory';
import ArticleOrderMediaWrapper from 'components/ArticleOrderMedia/ArticleOrderMediaWrapper';
import { useMediaOfferPermission } from 'hooks';

/**
 * @description Reddedilen madde detayı (yalnız `Reddedildi` statüsünde render edilir): red gerekçeleri +
 * heyet görüşü + medya tablosu.
 *
 * Medya tablosu salt-görüntülemedir; yetki prop'ları yalnız admin muafiyeti (`canManageAllRows`) ile
 * beslenir. Bu statüde aktif aşama olmadığı için bayrak bugün her kullanıcıda `false` döner — bağlantı,
 * admin'in aktif aşaması olmayan statülerde de yazabildiği BE tarafından teyit edilirse kendiliğinden
 * anlam kazanması için kuruldu.
 *
 * @param {Object} props
 * @param {Object} props.offer Madde teklifi (`ArticleOffer`) — statü, red gerekçeleri ve medya tablosunun kaynağı.
 */
const RejectedContentItem = ({ offer }) => {
  const mediaOfferPermission = useMediaOfferPermission(offer);

  return (
    <Card>
      <StatusBar status={offer.status} />
      <Card>
        <OrderDetailGrid offer={offer} />
      </Card>
      <Card>
        <ActivityHistory
          id={offer.id}
          requestType="post_offer"
        />
        <ArticleOrderMediaWrapper
          isContentSend
          offerID={offer.id}
          permission={mediaOfferPermission}
          isCommiteeControlColumnsVisible={!mediaOfferPermission.isReadOnly}
        />
      </Card>
      {offer?.revertReasons?.eu_control?.length > 0 && (
        <Card>
          <h3>Ansiklopedi biriminden aşağıdaki bilgiler doğrultusunda görüş istendi.</h3>
          <Card>
            {offer?.revertReasons?.eu_control?.map((item, index) => (
              <RevertAnswerItem
                key={index}
                title={item.revertReason.title}
                answer={item.answer}
              />
            ))}
          </Card>
        </Card>
      )}

      {offer?.ownerCommitteeOpinion && (
        <Card>
          <h3>Heyet Görüşü</h3>
          <span>{offer.ownerCommitteeOpinion}</span>
        </Card>
      )}
      {offer?.revertReasons?.ayk_control?.length > 0 && (
        <Card>
          <h3>Ansiklopedi Yonetim Kurulu aşağıdaki nedenlerle maddeyi reddetti.</h3>
          <Card>
            {offer?.revertReasons?.ayk_control?.map((item, index) => (
              <RevertAnswerItem
                key={index}
                title={item.revertReason.title}
                answer={item.answer}
              />
            ))}
          </Card>
        </Card>
      )}
    </Card>
  );
};

export default RejectedContentItem;
